export default "__VITE_ASSET__DUWvvwVH__"